const normalizeApiBase = (apiBase) => {
  const rawBase = typeof apiBase === 'string' && apiBase.trim()
    ? apiBase.trim()
    : '/api'

  return rawBase.endsWith('/') ? rawBase.slice(0, -1) : rawBase
}

export const getUploadUrlCandidates = (imageUrl, apiBase = process.env.REACT_APP_API_URL) => {
  if (!imageUrl || typeof imageUrl !== 'string') return []

  const trimmedUrl = imageUrl.trim()
  if (!trimmedUrl) return []

  if (trimmedUrl.startsWith('data:') || /^https?:\/\//i.test(trimmedUrl)) {
    return [trimmedUrl]
  }

  const apiRoot = normalizeApiBase(apiBase)
  const candidates = []
  const seen = new Set()

  const addCandidate = (candidate) => {
    if (!candidate || seen.has(candidate)) return
    seen.add(candidate)
    candidates.push(candidate)
  }

  if (trimmedUrl.startsWith('/api/uploads/')) {
    addCandidate(trimmedUrl)
    addCandidate(trimmedUrl.replace(/^\/api/, ''))
    return candidates
  }

  if (trimmedUrl.startsWith('/uploads/')) {
    addCandidate(`${apiRoot}${trimmedUrl}`)
    addCandidate(trimmedUrl)
    return candidates
  }

  if (trimmedUrl.startsWith('uploads/')) {
    addCandidate(`${apiRoot}/${trimmedUrl}`)
    addCandidate(`/${trimmedUrl}`)
    return candidates
  }

  if (trimmedUrl.startsWith('/')) {
    addCandidate(trimmedUrl)
    return candidates
  }

  addCandidate(`/${trimmedUrl}`)
  return candidates
}

export const resolveUploadUrl = (imageUrl, apiBase = process.env.REACT_APP_API_URL) =>
  getUploadUrlCandidates(imageUrl, apiBase)[0] || ''

export const handleUploadImageError = (event, imageUrl, finalFallbackSrc = '') => {
  const candidates = getUploadUrlCandidates(imageUrl)
  const currentIndex = Number(event.currentTarget.dataset.uploadFallbackIndex || '0')
  const nextIndex = currentIndex + 1

  if (nextIndex < candidates.length) {
    event.currentTarget.dataset.uploadFallbackIndex = String(nextIndex)
    event.currentTarget.src = candidates[nextIndex]
    return
  }

  event.currentTarget.onerror = null
  if (finalFallbackSrc) {
    event.currentTarget.src = finalFallbackSrc
  }
}
